import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

type SecretRowProps = { value: string; action?: ReactNode; className?: string };

/** A key, URL or secret in Geist Mono on a tone step, with an optional copy action. */
export function SecretRow({ value, action, className }: SecretRowProps) {
  return (
    <div
      className={cn(
        'flex min-h-10 min-w-0 items-center gap-1.5 rounded-control bg-surface-2 py-1 pr-1.5 pl-3',
        className,
      )}
    >
      <span className="flex-1 truncate font-mono text-mono">{value}</span>
      {action}
    </div>
  );
}
